import logo from "@img/common/logo.png"
import default_seat_img from "@img/common/default_seat.png"
export const brand_logo = logo
export const default_seat = default_seat_img
export const brand_title = "苏打爱生活"
export const consumption_const = "兑换";
export const element_const = "点";
export const purchase_const = "兑换";
export const balance_const = "额度"
export const amount_const = "额度"